import EmptyHolder from 'components/EmptyHolder'
import React from 'react'
import { Responses } from 'views/Feed/Responses'

const CodiRowComments = ({ id, type, style, className, header = null }) => {
  return (
    <div
      style={style}
      className={className}>
      {header}
      <Responses
        id={id}
        type={type}
        renderEmpty={() => <EmptyHolder />}
      />
    </div>
  )
}

export default CodiRowComments
